import React from 'react'
import { Link } from 'react-router-dom'

function stripHtml(html) {
  if (!html) return ''
  return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')
}

export default function ProductCard({ product }) {
  const slug = product.slug?._ || product.slug || ''
  const name = product.produktnavn || ''
  const rawImage = Array.isArray(product.produktbillede)
    ? product.produktbillede[0]
    : product.produktbillede || ''

  // Cloudflare image resize optimization
  const optimizedImage = rawImage.includes('assets.auxodev.dk')
    ? rawImage.replace('assets.auxodev.dk/', 'assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/')
    : rawImage

  const rawDesc = stripHtml(product.produktbeskrivelse)
  const shortDesc = rawDesc.length > 130 ? `${rawDesc.slice(0, 130).trim()}...` : rawDesc

  const categoryLabels = {
    kabiner: 'Kabiner',
    vandpoleringsmaskiner: 'Vandpoleringsmaskiner',
    'mobile-blaesere': 'Mobile Blæsere',
    kompressorer: 'Kompressorer',
    toerisblaesning: 'Tørisblæsning',
    forbrugsmaterialer: 'Forbrugsmaterialer',
    'reservedele-tilbehoer': 'Reservedele & Tilbehør',
    'kompressorer-udstyr': 'Kompressor & Udstyr',
  }
  // If product is in legacy "kabiner", refine based on product name
  let effectiveCat = product.produktkategori
  if (effectiveCat === 'kabiner') {
    const n = (product.produktnavn || '').toLowerCase()
    if (n.includes('wet') || n.includes('vandpoler') || n.includes('kwb')) {
      effectiveCat = 'vandpoleringsmaskiner'
    } else {
      effectiveCat = 'kabiner'
    }
  } else if (effectiveCat === 'kompressorer-udstyr') {
    const n = (product.produktnavn || '').toLowerCase()
    if (n.includes('ibix') || n.includes('blaster') || n.includes('mobil')) {
      effectiveCat = 'mobile-blaesere'
    } else {
      effectiveCat = 'kompressorer'
    }
  }
  const categoryLabel = categoryLabels[effectiveCat] || categoryLabels[product.produktkategori] || product.produktkategori

  return (
    <article className="group flex flex-col h-full bg-white rounded-none border border-slate-200/90 shadow-sm overflow-hidden transition-all duration-200 hover:shadow-md hover:border-slate-300">
      {/* Product Image Container */}
      <Link
        to={`/produkt/${slug}`}
        className="relative block aspect-[4/3] w-full bg-slate-100 overflow-hidden border-b border-slate-100 focus:outline-none"
        tabIndex={-1}
      >
        {optimizedImage ? (
          <img
            src={optimizedImage}
            alt={name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="flex items-center justify-center w-full h-full text-slate-300">
            <i className="fa-solid fa-industry text-4xl" aria-hidden="true" />
          </div>
        )}
      </Link>

      {/* Product Details */}
      <div className="flex flex-col flex-1 p-5">
        <h3 className="text-base font-bold text-slate-900 mb-2 group-hover:text-black transition-colors line-clamp-2">
          <Link to={`/produkt/${slug}`} className="focus:outline-none focus:underline hover:text-black">
            {name}
          </Link>
        </h3>

        <p className="text-xs text-slate-600 leading-relaxed line-clamp-3 mb-4 flex-1">
          {shortDesc}
        </p>

        {/* Card CTA Actions */}
        <div className="pt-3 border-t border-slate-100 flex items-center justify-between gap-2 mt-auto">
          <Link
            to={`/produkt/${slug}`}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-900 hover:text-black group/link"
          >
            <span>Se produkt</span>
            <i className="fa-solid fa-arrow-right text-[10px] transition-transform duration-200 group-hover/link:translate-x-1" aria-hidden="true" />
          </Link>

          <Link
            to={`/bestil?produkt=${slug}`}
            className="inline-flex items-center gap-1 text-slate-600 hover:text-black text-xs font-semibold transition-colors"
          >
            <i className="fa-solid fa-file-invoice text-[10px]" aria-hidden="true" />
            <span>Bestil</span>
          </Link>
        </div>
      </div>
    </article>
  )
}
